<template>
  <div class="container u-p1 mt-6">
    <div v-if="account">
      <div v-if="hasUser">
        <div class="columns">
          <div class="column is-4">
            <b-menu class="is-custom-mobile account-menu">
              <b-menu-list label="Menü">
                <b-menu-item class="account-menu-item is-size-7-mobile" @keydown.enter="focusElement('account-orders-view')" icon="tags" :label="$t('general.orders')" :active="$route.name == 'userorders'" tag="router-link" :to="{name: 'userorders'}"></b-menu-item>
                <b-menu-item class="account-menu-item is-size-7-mobile" icon="user-circle" :label="$t('general.my-data')" tag="router-link" :active="$route.name == 'user-edit-data'" :to="{name: 'user-edit-data'}"></b-menu-item>
                <b-menu-item class="account-menu-item is-size-7-mobile" icon="key" :label="$t('account.password-change')" tag="router-link" :active="$route.name == 'user-change-password'" :to="{name: 'user-change-password'}"></b-menu-item>
                <b-menu-item tabindex="0" class="account-menu-item is-size-7-mobile" @click="logout" icon="sign-out-alt" @keydown.enter="logout" :label="$t('general.logout')"></b-menu-item>
              </b-menu-list>
              <!-- <b-menu-list label="Actions">
                <b-menu-item @click="logout" icon="logout" label="Logout"></b-menu-item>
              </b-menu-list> -->
            </b-menu>
          </div>
          <div class="column">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </div>
        </div>
      </div>
      <div v-if="!hasUser" class="columns">
        <div class="column is-8-tablet is-offset-2-tablet is-4-fullhd is-offset-4-fullhd is-6-desktop is-offset-3-desktop">
          <LoginWindow class="box p-0" />
        </div>
      </div>
    </div>
    <div v-if="!account">
      <PasswordReset />
    </div>
  </div>
</template>

<script>
import LoginWindow from '@/components/Auth/LoginWindow'
import PasswordReset from './_components/PasswordReset'
import focusMixin from '@/mixins/focusMixin'
import {mapGetters} from 'vuex'
import store from './_store'
export default {
  name: 'AccountModule',
  components: {LoginWindow, PasswordReset},
  mixins: [focusMixin],
  computed: {
    account: function() {
      return this.$route.name !== 'reset-password'
    },
    ...mapGetters({
      hasUser: 'hasUser',
      userName: 'userName',
    }),
  },
  methods: {
    async logout() {
      await this.$store.dispatch('logout', {})
      this.focusElement('login-email')
    },
  },
  beforeCreate() {},
  created() {
    const STORE_KEY = '$_account'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  metaInfo() {
    if (this.hasUser) {
      return {
        title: 'Ihr Account',
        meta: [{name: 'description', content: 'Übersicht über Ihren Account!'}],
      }
    } else {
      return {
        title: 'Login / Registrierung',
        meta: [{name: 'description', content: 'Melden Sie sich an oder erstellen Sie einen neuen Account'}],
      }
    }
  },
  watch: {
    '$route.name'(newName) {
      this.$nextTick(() => {
        setTimeout(() => {
          const targetMap = {
            userorders: 'account-orders-view',
            'user-edit-data': 'account-change-user',
            'user-change-password': 'account-change-password',
          }
          const elId = targetMap[newName]
          const el = elId ? document.getElementById(elId) : null
          if (el) {
            el.focus()
          }
        }, 500)
      })
    },
  },
}
</script>

<style lang="scss">
@media screen and (max-width: 768px) {
  .account-menu {
    position: fixed;
    bottom: 0;
    background: #fff;
    left: 0;
    right: 0;
    z-index: 30;

    .menu-list {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
    }

    .menu-label {
      display: none;
    }
  }

  .account-menu-item {
    text-align: center;
    display: flex;
    justify-content: space-evenly;

    a {
      width: 100%;
    }

    .icon {
      display: block;
      margin: 0 auto 0.75rem !important;
      font-size: 1.2rem;
    }

    .icon-text {
      line-height: 1;
      padding-top: 0.5rem;
    }
  }
}
</style>
